'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'signal-bars';
var width = 448;
var height = 512;
var aliases = ["signal-alt","signal-alt-4","signal-bars-strong"];
var unicode = 'f690';
var svgPathData = 'M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384zM288 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288c0-17.7-14.3-32-32-32zM192 288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160zM64 416c0-17.7-14.3-32-32-32S0 398.3 0 416l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignalBars = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;